// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M7fE","rootMobile":"styles_rootMobile__2UbGr"};